import { IInitialCompanyState } from 'interfaces/company.interface';

const initialCompanyState: IInitialCompanyState = {
  company: null,
  isLoading: false,
  updateCompanyData: () => Promise.resolve(false),
  updateCompanyLogo: () => Promise.resolve(false),
  updateSocialMedia: () => Promise.resolve(false),
  removeSocialMedia: () => Promise.resolve(false),
  selectCompanySuperAdmin: () => Promise.resolve(false),
};

export default initialCompanyState;
